
export const getPermissionForPackage = async (componentName) => {
  try {
    const response = await fetch(`/nodeapi/portal/getpermissionforpackage?componentName=${componentName}`, {
      method: "GET",
      credentials: "include", 
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.errMsg || "Failed to fetch data");
    }

    const data= await response.json();

    return data.permission;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};


export const addPermission = async (email, componentName,role) => {
    const response = await fetch(`/nodeapi/portal/addpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, componentName, permission: role }),
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.errMsg || "Something went wrong!");
    }

    return data;
  
};


export const deletePermission = async (email, componentName) => {
  const response = await fetch(`/nodeapi/portal/deletepermission`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, componentName }),
    credentials: "include",
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.errMsg || "Something went wrong!");
  }
  return data;
  };


export const updatePermission = async (email, componentName, permission) => {
  const response = await fetch(`/nodeapi/portal/updatepermission`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, componentName, permission }),
    credentials: "include",
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.errMsg || "Something went wrong!");
  }
  return data;
  };  


   export const fetchAuthorInfo = async (authorHdId='') => {
      let result = null;
    try {
      await fetch(`/nodeapi/auth/getUserdataByUserid?hd_id=${authorHdId}`, {
        credentials: "include"
      }).then(response => response.json())
        .then(data => {
          result = data;
      
        }
        ).catch(error => {
          console.error('Error:', error);
        });
    } catch (error) {
      console.error('Error:', error);
    }
     return {
              displayName: result?.displayName,
              photoURL: result?.photoURL
            }
  }

  export const fetchBucketUrl = async (bucketType) => {
    try {
        const params = new URLSearchParams();
    params.append('bucketType', bucketType);
      const response = await fetch(`/nodeapi/fileUploads/getBucketServer?${params.toString()}`, {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }

      const data = await response.json();


      if (data && (data.url || data.urls)) {
        return bucketType !== '' ? data.url : data.urls;
      }else{
        throw new Error(`Not getting download url in api response`);;
      }

    } catch (err) {
      console.log(err);
    }
  }


  export const fetchNpmToken = async (bucketType) => {
    try {
        const params = new URLSearchParams();
    params.append('bucketType', bucketType);
      const response = await fetch(`/nodeapi/portal/generate-token-partner-portal`, {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }

      const data = await response.json();


      if (data && data.jwtauth) {
       return data.jwtauth;
      }else{
        throw new Error(`Not getting npm token in api response`);;
      }

    } catch (err) {
      console.log(err);
    }
  }



  export const fetchComponents = async (selectectedCategory, signal) => {
    try {
      const response = await fetch(`/nodeapi/portal/get-components?category=${selectectedCategory}`, {
        method: "GET",
        credentials: "include", 
        headers: {
          "Content-Type": "application/json",
        },
        // Forward abort signal so the browser cancels the request on category switch
        ...(signal ? { signal } : {}),
      });
  
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errMsg || "Failed to fetch data");
      }
  
      const data= await response.json();
  
      return data;
    } catch (error) {
      console.error("API Error:", error.message);
      throw error;
    }
  };

    export const fetchComponentHistory = async (componentName) => {
    try {
      const response = await fetch(`/nodeapi/portal/component-history?componentName=${componentName}`, {
        method: "GET",
        credentials: "include", 
        headers: {
          "Content-Type": "application/json",
        },
      });
  
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errMsg || "Failed to fetch data");
      }
  
      const apiResponse= await response.json();
  
      return {
        ...apiResponse,
        history: apiResponse?.data || apiResponse?.history || [],
        currentVersionOnProd: apiResponse?.currentVersionOnProd
      };
    } catch (error) {
      console.error("API Error:", error.message);
      throw error;
    }
  };

export async function getComponentDetails(componentName, templateName) {
  try {
    const params = new URLSearchParams();
    params.append("componentName", componentName);
    if(templateName){
      params.append("templateName", templateName);
    }

    const response = await fetch(
      `/nodeapi/portal/get-component-details?${params.toString()}`,
      {
        headers: { accept: "application/json" },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching component details:", error);
    throw error; 
  }
}


export const getFileForReview = async (componentName, version, flag = '') => {
  let url = `/nodeapi/portal/get-file-for-review?componentName=${componentName}&version=${version}`;
  if (flag) {
    url += `&flag=${flag}`;
  }

  const response = await fetch(url, {
    credentials: "include",
  });

  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.message || "Failed to load file");
  }

  return result.changes;  
};

export const requestDeveloperAccess = async (organization, role, description) => {
  const res = await fetch("/nodeapi/portal/developer-access", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ role, organization, description })
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || "Failed to request developer access");
  }

  return res.json(); 
}

// src/utils/apiPortal.js

export const fetchCategoriesAPI = async () => {
  try {
    const response = await fetch('/nodeapi/portal/component-categories', {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }

    return await response.json();

  } catch (err) {
    console.error("Error fetching categories:", err);
    throw err;
  }
};

export const fetchUserDataAPI = async () => {
  try {
    const response = await fetch("/nodeapi/auth/", {
      credentials: "include",
    });

    const data = await response.json();
    return data;

  } catch (err) {
    console.error("Error fetching user data:", err);
    throw err;
  }
};

export const fetchDeveloperInfo = async () => {
  try {
    const response = await fetch("/nodeapi/portal/developer-info", {
      credentials: "include",
    });

    const data = await response.json();
    return data?.developerInfo;

  } catch (err) {
    console.error("Error fetching user data:", err);
    throw err;
  }
};

export const getResourceJson = async (componentName, version) => {
  let url = `/nodeapi/portal/get-resource-json?componentName=${componentName}`;
  if (version) {
    url += `&version=${version}`;
  }
  const response = await fetch(url, {
    credentials: "include",
  });

  const result = await response.json();

  if (!response.ok || (result && result.success === 0)) {
    throw new Error(result?.message || result?.errMsg || "Failed to load resource.json");
  }

  return result?.changes !== undefined ? result.changes :
         result?.data !== undefined ? result.data :
         result?.content !== undefined ? result.content :
         result?.resource !== undefined ? result.resource : result;
};

export const updateTitleDescription = async (componentName, title, description) => {
  const payload = { componentName, title, description };

  const response = await fetch(`/nodeapi/portal/update-title-description`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || data.errMsg || "Failed to update resource.json");
  }

  return data;
};

export const updateTitleDescriptionOnProd = async (componentName, title, description, version, isStandalone) => {
  const payload = { componentName, title, description, version, isStandalone };

  const response = await fetch(`/nodeapi/portal/update-prod-title-description`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || data.errMsg || "Failed to update prod title and description");
  }

  return data;
};

export const getComponentDetailsFromProd = async (componentName) => {
  try {
    const params = new URLSearchParams();
    params.append("componentName", componentName);

    const response = await fetch(
      `/nodeapi/portal/get-componentdetails-from-prod?${params.toString()}`,
      {
        headers: { accept: "application/json" },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching prod component details:", error);
    throw error;
  }
};
